import {
  GET_VENDOR_EVENTS,
  GET_VENDOR_EVENTS_SUCCESS,
  GET_VENDOR_EVENTS_FAILED,
  FIND_VENDOR_EVENT_REGISTERED,
  REGISTER_VENDOR_EVENT,
  REGISTER_VENDOR_EVENT_SUCCESS,
  VENDOR_EVENT_NOT_REGISTERED,
  REGISTER_VENDOR_EVENT_FAILED,
  SET_VENDOR_EVENT_PAYLOAD,
  UPDATE_APPLICATION_STATUS,
  UPDATE_APPLICATION_STATUS_SUCCESS,
  UPDATE_APPLICATION_STATUS_FAILED,
  CREATE_STRIPE_CHECKOUT_SESION,
  CREATE_STRIPE_CHECKOUT_SESION_SUCCESS,
  CREATE_STRIPE_CHECKOUT_SESION_FAILED,
  SET_TOTAL_AMOUNT_DUE,
  RESET_VENDOR_EVENT,
  GET_VENDOR_EVENTS_WITHOUT_FILTERS_FAILED,
  GET_VENDOR_EVENTS_WITHOUT_FILTERS_SUCCESS,
  GET_VENDOR_EVENTS_WITHOUT_FILTERS,
  GET_VENDOR_EVENTS_BY_EVENT,
  GET_VENDOR_EVENTS_BY_EVENT_SUCCESS,
  GET_VENDOR_EVENTS_BY_EVENT_FAILED,
  CREATE_EVENT_APPLICATION,
  CREATE_EVENT_APPLICATION_SUCCESS,
  CREATE_EVENT_APPLICATION_FAILED,
  CANCEL_EVENT_REGISTRATION,
  CANCEL_EVENT_REGISTRATION_SUCCESS,
  CANCEL_EVENT_REGISTRATION_FAILED,
  REFUND,
  REFUND_SUCCESS,
  REFUND_FAILED,
  ON_SEARCH_VENDORS_EVENT,
  GET_ALL_VENDOR_EVENTS,
  GET_ALL_VENDOR_EVENTS_SUCCESS,
  GET_ALL_VENDOR_EVENTS_FAILED,
  ON_SEARCH_ALL_VENDORS_EVENT,
  GET_REFUNDS,
  GET_REFUNDS_FAILED,
  GET_REFUNDS_SUCCESS,
  CREATE_REFUND_REQUEST,
  CREATE_REFUND_REQUEST_FAILED,
  CREATE_REFUND_REQUEST_SUCCESS,
  GET_VENDOR_UNPAID_EVENT_REGISTRATIONS,
  GET_VENDOR_UNPAID_EVENT_REGISTRATIONS_SUCCESS,
  GET_VENDOR_UNPAID_EVENT_REGISTRATIONS_FAILED,
  GET_VENDOR_PAID_EVENT_REGISTRATIONS,
  GET_VENDOR_PAID_EVENT_REGISTRATIONS_SUCCESS,
  GET_VENDOR_PAID_EVENT_REGISTRATIONS_FAILED,
} from './constants';

const resetVendorEventState = () => ({ type: RESET_VENDOR_EVENT });

const getVendorEvents = (vendorId) => ({
  type: GET_VENDOR_EVENTS,
  payload: { vendorId },
});

const getVendorEventSuccess = (events) => ({
  type: GET_VENDOR_EVENTS_SUCCESS,
  payload: { events },
});

const getVendorEventsFailed = (error) => ({
  type: GET_VENDOR_EVENTS_FAILED,
  payload: { error },
});

const getVendorEventsWithoutFilters = (vendorId) => ({
  type: GET_VENDOR_EVENTS_WITHOUT_FILTERS,
  payload: { vendorId },
});

const getVendorEventsWithoutFilterSuccess = (events) => ({
  type: GET_VENDOR_EVENTS_WITHOUT_FILTERS_SUCCESS,
  payload: { events },
});

const getVendorEventsWithoutFiltersFailed = (error) => ({
  type: GET_VENDOR_EVENTS_WITHOUT_FILTERS_FAILED,
  payload: { error },
});

const findVendorEventRegistered = (vendorId, eventId) => ({
  type: FIND_VENDOR_EVENT_REGISTERED,
  payload: { vendorId, eventId },
});

const registerVendorEvent = (payload) => ({
  type: REGISTER_VENDOR_EVENT,
  payload,
});

const registerVendorEventSuccess = (data) => ({
  type: REGISTER_VENDOR_EVENT_SUCCESS,
  payload: { data },
});
const vendorEventNotRegistered = () => ({
  type: VENDOR_EVENT_NOT_REGISTERED,
});

const registerVendorEventFailed = (error) => ({
  type: REGISTER_VENDOR_EVENT_FAILED,
  payload: { error },
});

const setVendorEventPayload = (payload) => ({
  type: SET_VENDOR_EVENT_PAYLOAD,
  payload,
});

const updateEventApplicationStatus = (vendorId, eventId, newStatus, onStatusChanged) => ({
  type: UPDATE_APPLICATION_STATUS,
  payload: { vendorId, eventId, newStatus, onStatusChanged },
});

const updateEventApplicationStatusSuccess = (vendorEventData) => ({
  type: UPDATE_APPLICATION_STATUS_SUCCESS,
  payload: { vendorEventData },
});

const updateEventApplicationStatusFailed = (error) => ({
  type: UPDATE_APPLICATION_STATUS_FAILED,
  payload: { error },
});

const createStripeCheckoutSession = (payload) => ({
  type: CREATE_STRIPE_CHECKOUT_SESION,
  payload,
});

const createStripeCheckoutSessionSuccess = (payload) => ({
  type: CREATE_STRIPE_CHECKOUT_SESION_SUCCESS,
  payload,
});

const createStripeCheckoutSessionFailed = (error) => ({
  type: CREATE_STRIPE_CHECKOUT_SESION_FAILED,
  payload: { error },
});

const createEventApplication = ({ vendorId, eventId, totalPrice }) => ({
  type: CREATE_EVENT_APPLICATION,
  payload: { vendorId, eventId, totalPrice },
});

const createEventApplicationSuccess = (vendorEvent) => ({
  type: CREATE_EVENT_APPLICATION_SUCCESS,
  payload: { vendorEvent },
});

const createEventApplicationFailed = (error) => ({
  type: CREATE_EVENT_APPLICATION_FAILED,
  payload: { error },
});

const toSetTotalAmountDue = (value) => ({
  type: SET_TOTAL_AMOUNT_DUE,
  payload: { value },
});

const getVendorEventsByEvent = (eventId) => ({
  type: GET_VENDOR_EVENTS_BY_EVENT,
  payload: { eventId },
});

const getVendorEventsByEventSuccess = (events) => ({
  type: GET_VENDOR_EVENTS_BY_EVENT_SUCCESS,
  payload: { events },
});

const getVendorEventsByEventFailed = (error) => ({
  type: GET_VENDOR_EVENTS_BY_EVENT_FAILED,
  payload: { error },
});

const getAllVendorEvents = () => ({
  type: GET_ALL_VENDOR_EVENTS,
});

const getAllVendorEventsSuccess = (events) => ({
  type: GET_ALL_VENDOR_EVENTS_SUCCESS,
  payload: { events },
});

const getAllVendorEventsFailed = (error) => ({
  type: GET_ALL_VENDOR_EVENTS_FAILED,
  payload: { error },
});

const cancelEventRegistration = (eventId, vendorId) => ({
  type: CANCEL_EVENT_REGISTRATION,
  payload: { eventId, vendorId },
});

const cancelEventRegistrationSuccess = (cancelledEvent) => ({
  type: CANCEL_EVENT_REGISTRATION_SUCCESS,
  payload: { cancelledEvent },
});

const cancelEventRegistrationFailed = (error) => ({
  type: CANCEL_EVENT_REGISTRATION_FAILED,
  payload: { error },
});

const createRefund = (asset, reason, amountRequested, eventId, userId) => ({
  type: REFUND,
  payload: { asset, reason, amountRequested, eventId, userId },
});

const createRefundSuccess = (refund) => ({
  type: REFUND_SUCCESS,
  payload: { refund },
});

const createRefundFailed = (error) => ({
  type: REFUND_FAILED,
  payload: { error },
});

const getRefund = (eventId) => ({
  type: GET_REFUNDS,
  payload: { eventId },
});

const getRefundSuccess = (refund) => ({
  type: GET_REFUNDS_SUCCESS,
  payload: { refund },
});

const getRefundFailed = (error) => ({
  type: GET_REFUNDS_FAILED,
  payload: { error },
});

const createRefundRequest = (refundId, vendorId, status) => ({
  type: CREATE_REFUND_REQUEST,
  payload: { refundId, vendorId, status },
});

const createRefundRequestSuccess = (refund) => ({
  type: CREATE_REFUND_REQUEST_SUCCESS,
  payload: { refund },
});

const createRefundRequestFailed = (error) => ({
  type: CREATE_REFUND_REQUEST_FAILED,
  payload: { error },
});

const onSearchVendorsEvent = (text) => ({
  type: ON_SEARCH_VENDORS_EVENT,
  payload: { text },
});

const onSearchAllVendorsEvent = (text) => ({
  type: ON_SEARCH_ALL_VENDORS_EVENT,
  payload: { text },
});

const getVendorUnpaidEventRegistrations = (vendorId) => ({
  type: GET_VENDOR_UNPAID_EVENT_REGISTRATIONS,
  payload: { vendorId },
});

const getVendorUnpaidEventRegistrationsSuccess = (registrations) => ({
  type: GET_VENDOR_UNPAID_EVENT_REGISTRATIONS_SUCCESS,
  payload: { registrations },
});

const getVendorUnpaidEventRegistrationsFailed = (error) => ({
  type: GET_VENDOR_UNPAID_EVENT_REGISTRATIONS_FAILED,
  payload: { error },
});

const getVendorPaidEventRegistrations = (vendorId) => ({
  type: GET_VENDOR_PAID_EVENT_REGISTRATIONS,
  payload: { vendorId },
});

const getVendorPaidEventRegistrationsSuccess = (registrations) => ({
  type: GET_VENDOR_PAID_EVENT_REGISTRATIONS_SUCCESS,
  payload: { registrations },
});

const getVendorPaidEventRegistrationsFailed = (error) => ({
  type: GET_VENDOR_PAID_EVENT_REGISTRATIONS_FAILED,
  payload: { error },
});

export {
  getVendorEvents,
  getVendorEventSuccess,
  getVendorEventsFailed,
  getVendorEventsWithoutFilters,
  getVendorEventsWithoutFilterSuccess,
  getVendorEventsWithoutFiltersFailed,
  findVendorEventRegistered,
  registerVendorEvent,
  registerVendorEventSuccess,
  vendorEventNotRegistered,
  registerVendorEventFailed,
  setVendorEventPayload,
  updateEventApplicationStatus,
  updateEventApplicationStatusSuccess,
  updateEventApplicationStatusFailed,
  createStripeCheckoutSession,
  createStripeCheckoutSessionSuccess,
  createStripeCheckoutSessionFailed,
  toSetTotalAmountDue,
  resetVendorEventState,
  getVendorEventsByEvent,
  getVendorEventsByEventSuccess,
  getVendorEventsByEventFailed,
  createEventApplication,
  createEventApplicationSuccess,
  createEventApplicationFailed,
  cancelEventRegistration,
  cancelEventRegistrationSuccess,
  cancelEventRegistrationFailed,
  onSearchVendorsEvent,
  onSearchAllVendorsEvent,
  getAllVendorEvents,
  getAllVendorEventsSuccess,
  getAllVendorEventsFailed,
  createRefund,
  createRefundSuccess,
  createRefundFailed,
  getRefund,
  getRefundFailed,
  getRefundSuccess,
  createRefundRequest,
  createRefundRequestSuccess,
  createRefundRequestFailed,
  getVendorUnpaidEventRegistrations,
  getVendorUnpaidEventRegistrationsSuccess,
  getVendorUnpaidEventRegistrationsFailed,
  getVendorPaidEventRegistrations,
  getVendorPaidEventRegistrationsSuccess,
  getVendorPaidEventRegistrationsFailed,
};
